import ExcelResultTable from "./ExcelResultTable";
import CalculationWarning from "./CalculationWarning";
import {
  Box,
  Paper,
  Typography,
  Backdrop,
  CircularProgress,
} from "@mui/material";

const VacuumBreakerCalculation = ({ data, loading, error }) => {

  return (
    <Box sx={{ width: '100%', position: 'relative' }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          mb: 2,
        }}
      >
      </Box>
      {error ? (
        <CalculationWarning error={error} />
      ) : data != null ? (
        <Box sx={{ width: '100%' }}>
          <Box >
            <Paper sx={{ p: 2, minHeight: 400, height: '100%' }}>
              <Typography
                variant="subtitle1"
                fontWeight={600}
                mb={2}
                textAlign="center"
              >
                Vacuum Breaker
              </Typography>

              <ExcelResultTable
                tableType="VACUUM_BREAKER"
                isTower={false}
                data={data}
              />
            </Paper>
          </Box>

        </Box>
      ) : (
        <CalculationWarning />
      )}

      <Backdrop
        open={loading}
        sx={{
          position: 'absolute',
          inset: 0,
          bgcolor: 'rgba(255,255,255,0.8)',
          zIndex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress color="inherit" size={40} />
      </Backdrop>
    </Box>
  );
};


export default VacuumBreakerCalculation;